import React from 'react';

import RefreshRoundedIcon from '@mui/icons-material/RefreshOutlined';

import OlcButton from '~/components/General/OlcButton';
import OlcDatePicker from '~/components/General/OlcDatePicker';
import OlcDropdownSearch from '~/components/General/OlcDropdownSearch';

const DashboardHeader = ({
  title,
  subtitle,
  lastRefreshed,
  isRefreshing,
  dateRange,
  onRefresh,
}) => (
  <header className="mail-performance-header">
    <div>
      <div className="mail-performance-title-row">
        <h1>{title}</h1>
      </div>
      <p>{subtitle}</p>
    </div>
    <div className="mail-performance-filters">
      <span>
        Last refreshed <strong>{lastRefreshed}</strong>
      </span>
      <OlcButton
        variant="secondary"
        iconOnly
        className={`refresh-button ${isRefreshing ? 'is-refreshing' : ''}`}
        aria-label="Refresh dashboard"
        onClick={onRefresh}
        disabled={isRefreshing}
        startIcon={<RefreshRoundedIcon />}
      >
        Refresh
      </OlcButton>
      <div className="dashboard-date-control">
        {dateRange.isCustomDateOpen ? (
          <div className="dashboard-date-picker mailedDate newDatePicker updatedDesign">
            <div className="selectDate">
              <OlcDatePicker
                open
                calendarClassName="dashboard-date-calendar"
                popperModifiers={[
                  {
                    name: 'offset',
                    // Recalculate bottom-end placement using the custom popover width.
                    options: { offset: [0, 0] },
                  },
                ]}
                popperPlacement="bottom-end"
                popperWidth={244}
                selectsRange
                startDate={dateRange.customDateRange[0]}
                endDate={dateRange.customDateRange[1]}
                onChange={(nextRange) => {
                  dateRange.setCustomDateRange(nextRange);
                  dateRange.applyCustomDate(nextRange);
                }}
                onClickOutside={() => dateRange.setIsCustomDateOpen(false)}
                onCalendarClose={() => dateRange.setIsCustomDateOpen(false)}
                minDate={null}
                toggleCalendarOnIconClick={true}
                placeholderText="Select date range"
                isClearable
              />
            </div>
          </div>
        ) : (
          <div className="dashboard-date-dropdown" title={dateRange.selectedDate.title}>
            <OlcDropdownSearch
              options={dateRange.dateOptions}
              selectedValue={dateRange.selectedDate}
              setSelectedValue={(nextDate) => {
                dateRange.setSelectedDate(nextDate);
                dateRange.setIsCustomDateOpen(false);
              }}
              searchable={false}
              placeHolderText="Select date"
              component="overviewdateDropDown"
              controlVariant="secondary"
            />
          </div>
        )}
      </div>
    </div>
  </header>
);

export default DashboardHeader;
